import { formatUrl } from 'url-lib';
import { sdkRequest } from '@eb/http';

export const getCollectionEventsWithSearch = ({
    id: collectionId,
    continuation,
    pageSize = 20,
}) =>
    sdkRequest(`/api/v3/destination/search/`, {
        method: 'POST',
        body: JSON.stringify({
            event_search: {
                collections_or: [collectionId],
                include_mature_events: true,
                dates: 'current_future',
                page_size: pageSize,
                sort: 'date',
                continuation,
            },
            'expand.destination_event': [
                'primary_venue',
                'image',
                'ticket_availability',
                'saves',
                'my_collections',
                'series',
            ],
        }),
    });

export const getCollectionEvents = ({
    id: collectionId,
    continuation,
    secret,
    pageSize = 20,
}) => {
    const url = formatUrl(
        `/api/v3/destination/collections/${collectionId}/events/`,
        {
            'expand.destination_event': [
                'primary_venue',
                'image',
                'ticket_availability',
                'saves',
                'my_collections',
                'series',
            ],
            dates: 'current_future',
            page_size: pageSize,
            continuation,
            secret,
        },
    );

    return sdkRequest(url);
};

export const removeEventsFromCollection = (collectionId, events = []) =>
    sdkRequest(
        `/api/v3/destination/collections/${collectionId}/events/remove/`,
        {
            method: 'POST',
            body: JSON.stringify({
                'expand.destination_event': [
                    'primary_venue',
                    'image',
                    'ticket_availability',
                    'saves',
                    'my_collections',
                    'series',
                ],
                event_ids: events,
            }),
        },
    );
